import { useCopyToClipBoard } from "hooks/useCopyToClipBoard";
import SetCbuAliasForm from "pages/accounts/_components/Forms/SetCbuAliasForm";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import Drawer from "pages/_components/Drawer/Drawer";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { resizableRoute as resizableComponent } from "pages/_components/Resizable";
import React, { useEffect, useState } from "react";
import gaEventTracker, { events } from "util/gaEventTracker";
import * as i18n from "util/i18n";
import { Col, Grid, Row } from "react-bootstrap";
import { isIOS, isMobile } from "react-device-detect";
import CustomText from "pages/_components/CustomText/CustomText";
import { customDetailAccountPropType, defaultCustomDetailAccountPropType } from "./customDetailAccountPropType";

const productTypes = { CA: "savings", CC: "checking", CE: "specialChecking", CBB: "CBB" };

const AccountDetails = (props) => {
    const { account, openQr, toggleSidebar, isDesktop } = props;
    const { componentRef, handlePrint } = useReactPrint("Detalle de la cuenta", account.productiD);
    const [alias, setAlias] = useState(account?.cbuAlias);
    useEffect(() => {
        setAlias(account?.cbuAlias);
    }, [account?.cbuAlias]);

    const copyData = {
        productType: `${i18n.get(`accounts.productType.${productTypes[account.productType]}`)} en ${account.currency}`,
        cbu: account.uniformBankCode,
        owner: account.owner,
        accountNumber: account.accountNumber,
        alias,
        cuit: account.taxBankCode,
    };

    const { handleCopyToClipBoard } = useCopyToClipBoard(isDesktop, "account.details.textCopy", copyData);

    const [openSideForm, setOpenSideForm] = useState(false);

    const handleEdit = () => {
        setOpenSideForm(true);
        toggleSidebar(false);
    };

    const handleDownload = () => {
        gaEventTracker.triggerEvent(events.cuentas_detalle_descargar());
        handlePrint();
    };

    const handleShare = () => {
        gaEventTracker.triggerEvent(events.cuentas_detalle_compartir());
        handleCopyToClipBoard("account/details");
    };
    const handleQr = () => {
        gaEventTracker.triggerEvent(events.cuentas_detalle_QR());
        openQr();
    };

    const onClose = () => {
        toggleSidebar(true);
        setOpenSideForm(false);
    };

    return (
        <div className="container full-width">
            <article
                className={
                    isIOS
                        ? "container transaction-ticket accounts__details height-80"
                        : "container transaction-ticket accounts__details"
                }
                ref={componentRef}>
                <Grid>
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} mdOffset={1} lg={10} lgOffset={1} className="text-left">
                            <div className="voucher-header">
                                <Image src="images/logoCompany.svg" />
                                <div
                                    className="bibank-data hidden show-print"
                                    dangerouslySetInnerHTML={{ __html: i18n.get("report.bibank.header") }}
                                />
                            </div>
                        </Col>
                        <Col xs={12} md={10} mdOffset={1} lg={10} lgOffset={1} className="text-center">
                            <h2 className="title-content">
                                <CustomText text="accounts.details" textType="I18N" />
                            </h2>
                        </Col>
                        <Col xs={12} md={10} mdOffset={1} lg={10} lgOffset={1} className="text-left">
                            <GridTable>
                                <GridTable.Container
                                    className="box box-shadow accounts__details-box"
                                    columns={1}
                                    rows={8}>
                                    <GridTable.Data ccolumnStart={1} rowStart={1}>
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="accounts.details.information.taxCode.label"
                                            titleTextType="I18N"
                                            valueText={account.taxBankCode}
                                        />
                                    </GridTable.Data> 
                                    <GridTable.Data columnStart={1} rowStart={2}>
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="accounts.details.information.owners.label"
                                            titleTextType="I18N"
                                            titleClass="text-Primary-primary-color"
                                            valueText={account.owner}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={3}>
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="accounts.details.information.accountType.label"
                                            titleTextType="I18N"
                                            titleClass="text-Primary-primary-color"
                                            valueText={`${i18n.get(
                                                `accounts.productType.${productTypes[account.productType]}`,
                                            )} en ${account.currency}`}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={4}>
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="accounts.details.information.uniformBankCode.label"
                                            titleTextType="I18N"
                                            titleClass="text-Primary-primary-color"
                                            valueText={account.uniformBankCode}
                                        />
                                    </GridTable.Data>                               
                                    <GridTable.Data columnStart={1} rowStart={5}>
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="accounts.details.information.accountNumber.label"
                                            titleTextType="I18N"
                                            valueText={account.number}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data
                                        columnStart={1}
                                        rowStart={6}
                                        className="accounts__details-alias">
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="accounts.details.information.alias.label"
                                            titleTextType="I18N"
                                            valueText={alias}
                                        />
                                        <Button
                                            style={{ width: "50%" }}
                                            image="images/editPen.svg"
                                            onClick={handleEdit}
                                            label="accounts.details.information.alias.setAlias"
                                            bsStyle="link"
                                            className="no-print"
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>

                                <Button
                                    className="btn-primary no-print"
                                    image="images/figma/icon/download.svg"
                                    label="global.download"
                                    onClick={handleDownload}
                                    block
                                />
                                <Button
                                    className="btn-outline no-print"
                                    image="images/figma/icon/share.svg"
                                    label="global.share"
                                    block
                                    onClick={handleShare}
                                />
                                <Button
                                    className="btn-outline no-print"
                                    image="images/figma/icon/qr.svg"
                                    label="accounts.details.showQr"
                                    block
                                    onClick={handleQr}
                                />
                            </GridTable>
                            <Drawer
                                openSidebar={openSideForm}
                                onClose={onClose}
                                isFullHeight={isMobile || isIOS}
                                enableCloseButton={!!isDesktop}>
                                <SetCbuAliasForm
                                    idAccount={account.idProduct}
                                    cbu={account.uniformBankCode}
                                    closeSidebar={setOpenSideForm}
                                    setNewAlias={setAlias}
                                    oldAlias={alias}
                                    toggleSidebar={toggleSidebar}
                                />
                            </Drawer>
                        </Col>
                    </Row>
                </Grid>
            </article>
        </div>
    );
};

AccountDetails.propTypes = customDetailAccountPropType;
AccountDetails.defaultProps = defaultCustomDetailAccountPropType;

export default resizableComponent(AccountDetails);
